module.exports = __webpack_public_path__ + "img/apiImg.5f4962f1.png";